import { render } from "./THead.vue?vue&type=template&id=89ca737e&scoped=true"
import script from "./THead.vue?vue&type=script&lang=js"
export * from "./THead.vue?vue&type=script&lang=js"

import "./THead.vue?vue&type=style&index=0&id=89ca737e&lang=scss&scoped=true"
import "./THead.vue?vue&type=style&index=1&id=89ca737e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ca737e"]])

export default __exports__